<template>
    <section v-if="goodInvestment">
        <div class="inline bg-default corner lh-normal outline">
            <div class="flex vertical top" v-ga:impression="'movoto-pick-banner'">
                <div class="flex middle left"><i class="icon icon-money circle danger small active"></i> <div class="text-bold f4"><span class="text-danger text-bold">Investment Opportunity</span></div> </div>
                <div>
                    The estimated monthly rental is greater than the monthly mortgage payment, taxes, hoa fees, and insurance.
                </div>
                <template  v-if="dpp.isActive">
                    <div>
                        <b class="f6">{{getVisitTimings.isCutOffPassed ? 'Request a Tour Tomorrow': 'Request a Tour Today'}}</b>
                    </div>
                    <div class="flex left wrap">
                        <button type="button" v-for="(time,i) in getVisitTimings.displayTimings" :key="i" class="btn secondary small" @click="popTourHotlead">{{time}}</button> <button type="button" class="btn secondary small" @click="openhotlead1(molang('dpp.hotButton.requestTour'))">More Times</button>
                    </div>
                </template>
                <div v-else>
                    <button type="button" class="btn secondary small"  @click="popSoldlead('Connect with a Real Estate Agent', 'Go')">Connect with a Real Estate Agent</button>
                </div>
            </div>
        </div>
    </section>
    <section v-else-if="hotMarket" >
        <div class="inline bg-default corner lh-normal outline">
            <div class="flex vertical top" v-ga:impression="'hot-market-banner'">
                <div class="flex middle space-between">
                    <div>
                        <i class="icon icon-hot circle danger small active"></i>
                        <span class="text-bold f4"> {{dpp.geo.city.length > 17 ? dpp.geo.zipcode : dpp.geo.city}} is <a class="text-red text-bold" @click="popHotHomelead" role="button">{{ dpp.avgPendingDays > 14 ? 'HOT' : 'VERY HOT' }}</a></span>
                    </div>
                    <a @click="openHotMarketPop" tracked="tracked" role="button"><i class="icon-Info-Circle"></i></a>
                </div>
                <div>
                    Homes likely to be in contract in <a class="underdash" @click="openHotMarketPop" role="button">{{dpp.avgPendingDays}} day{{dpp.avgPendingDays>1?'s':''}}</a>
                </div>
                <template  v-if="dpp.isActive">
                    <div>
                        <b class="f6" v-if="dpp.isActive">{{getVisitTimings.isCutOffPassed ? 'Request a Tour Tomorrow': 'Request a Tour Today'}}</b>
                        <b class="f6" v-else >{{getVisitTimings.isCutOffPassed ? 'Request a consultation tomorrow': 'Request a consultation today'}}</b>
                    </div>
                    <div class="flex left wrap">
                        <button type="button" v-for="(time,i) in getVisitTimings.displayTimings" :key="i" class="btn secondary small" @click="popTourHotlead">{{time}}</button> <button type="button" class="btn secondary small" @click="openhotlead1(molang('dpp.hotButton.requestTour'))">More Times</button>
                    </div>
                </template>
                <div v-else>
                    <button type="button" class="btn secondary small" @click="popSoldlead('Connect with a Real Estate Agent', 'Go')">
                        Connect with a Real Estate Agent
                    </button>
                </div>
            </div>
        </div>
    </section>
    <section v-else-if="showPriceDropBanner">
        <div class="inline bg-default corner lh-normal outline">
            <div class="flex vertical top" v-ga:impression="'price-cut-banner'">
                <div class="flex middle left"><i class="icon icon-trend-down circle main small active"></i> <div class="text-bold f4"><span class="text-main text-bold">Recent Price Cut</span></div> </div>
                <div>
                    Home price reduced by {{$filters.formatFriendlyPrice(dpp.priceChange)}} {{priceReducedBy}}. This could mean the seller is motivated.
                </div>
                <template v-if="dpp.isActive">
                    <div>
                        <b class="f6" v-if="dpp.isActive">{{getVisitTimings.isCutOffPassed ? 'Request a Tour Tomorrow': 'Request a Tour Today'}}</b>
                        <b class="f6" v-else >{{getVisitTimings.isCutOffPassed ? 'Request a consultation tomorrow': 'Request a consultation today'}}</b>
                    </div>
                    <div class="flex left wrap">
                        <button type="button" v-for="(time,i) in getVisitTimings.displayTimings" :key="i" class="btn secondary small" @click="popTourHotlead">{{time}}</button> <button type="button" class="btn secondary small" @click="openhotlead1(molang('dpp.hotButton.requestTour'))">More Times</button>
                    </div>
                </template>
                <div v-else>
                    <button type="button" class="btn secondary small"  @click="popSoldlead('Connect with a Real Estate Agent', 'Go')">Connect with a Real Estate Agent</button>
                </div>
            </div>
        </div>
    </section>
</template>

<script src="./dpp-banner.js"></script>

